import { ENDPOINTS } from 'config/endpoints';
import { useMutation } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { RewriteMessageInput } from 'crono-fe-common/types/DTO/rewriteMessage';
import {
  CUSTOMER_SCORE_EVENTS,
  useCustomerScore,
} from 'context/analytics/useCustomerScore';

export default function useRewriteMessage() {
  const customerScore = useCustomerScore();

  const rewriteMessage = (rewriteInput: RewriteMessageInput) => {
    const request: Request = {
      url: `${ENDPOINTS.assistant.rewrite}`,
      config: {
        method: 'post',
        data: { data: rewriteInput },
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<string>,
    CronoError,
    RewriteMessageInput
  >(rewriteMessage, {
    onSuccess: () => {
      customerScore?.track(CUSTOMER_SCORE_EVENTS.REWRITE);
    },
  });

  return { data, mutate, ...rest };
}
